var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import * as S from './modal.style';
import { GoBackArrow } from '../../atoms/Svgs';
import { CloseLine, neutralDay } from '@teamsparta/design-system';
import { useAtom, useAtomValue } from 'jotai';
import { hideCloseBtnAtom, hideGoBackBtnAtom, INITIATE, POP, readModalHistoryAtom, readWriteModalHistoryAtom, Tasks, } from '../../../stores';
import { removeWelcomeQueryStringParam } from '../../../businessLogics/hooks';
import { sendLog } from '../../../logging';
import { getBrandByLocation } from '../../../businessLogics';
import { useUserInfo } from '../../../businessLogics/apis';
var Modal = function (_a) {
    var children = _a.children, isShow = _a.isShow, setIsShow = _a.setIsShow, isFitContent = _a.isFitContent, setIsAborted = _a.setIsAborted, CPLogger = _a.CPLogger;
    var _b = useAtom(readWriteModalHistoryAtom), currentTask = _b[0], updateHistory = _b[1];
    var history = useAtomValue(readModalHistoryAtom);
    var userInfo = useUserInfo();
    var _c = useAtom(hideGoBackBtnAtom), hideGoBack = _c[0], setHideGoBack = _c[1];
    var _d = useAtom(hideCloseBtnAtom), hideClose = _d[0], setHideClose = _d[1];
    useEffect(function () {
        if ([Tasks.INITIAL, Tasks.SIGNUP_WELCOME].includes(currentTask) || history.length <= 1) {
            setHideGoBack(true);
        }
        else {
            setHideGoBack(false);
        }
    }, [currentTask, history]);
    var onClickClose = function () {
        var _a;
        removeWelcomeQueryStringParam();
        if (currentTask === Tasks.SIGNUP_WELCOME) {
            sendLog("".concat(getBrandByLocation(), "_marketingGrabPopUp_click"), CPLogger, { button_text: 'X' }, (_a = userInfo.data) === null || _a === void 0 ? void 0 : _a._id);
        }
        setIsShow(false);
        setIsAborted && setIsAborted(true);
        if (![Tasks.CHANGE_EMAIL_ENTER, Tasks.CHANGE_PHONE_NUMBER_ENTER_AND_AUTH, Tasks.CHANGE_PASSWORD_ENTER].includes(currentTask)) {
            updateHistory({ action: INITIATE });
        }
    };
    return (_jsx(S.Wrapper, __assign({ isFullPage: currentTask === Tasks.SIGNUP_EMAIL, isFitContent: isFitContent }, { children: _jsxs(S.Modal, __assign({ isFullPage: currentTask === Tasks.SIGNUP_EMAIL, isShow: isShow, isFitContent: isFitContent }, { children: [_jsxs(S.TopContainer, { children: [!hideGoBack && (_jsxs(S.TopBtn, __assign({ isLeft: true, onClick: function () {
                                updateHistory({ action: POP });
                            } }, { children: [_jsx(GoBackArrow, {}), " \uB4A4\uB85C"] }))), !hideClose && (_jsx(S.TopBtn, __assign({ onClick: onClickClose }, { children: _jsx(CloseLine, { size: 20, color: neutralDay.gray90 }) })))] }), _jsx(S.Contents, __assign({ isFullPage: currentTask === Tasks.SIGNUP_EMAIL, currentTask: currentTask }, { children: children }))] })) })));
};
export default Modal;
//# sourceMappingURL=Modal.js.map